"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderIcon = void 0;
var react_1 = __importDefault(require("react"));
var LoaderIcon_style_1 = __importDefault(require("./LoaderIcon.style"));
exports.LoaderIcon = function (_a) {
    var size = _a.size, color = _a.color;
    return (react_1.default.createElement(LoaderIcon_style_1.default, { color: color, size: size },
        react_1.default.createElement("div", { className: "loading-icon-loader" })));
};
//# sourceMappingURL=LoaderIcon.js.map